import React from "react";
import "./About.css";
// import ProductSlider from "../pages/ProductSlider";
import AboutPage from "../pages/AboutPage";

export default function About() {

  return (
    <section id="about" className="emk-about-section">
      <AboutPage />
      {/* <ProductSlider /> */}
    </section>
  );
}
